export const ENV = {
  flavor: process.env.NEXT_PUBLIC_FLAVOR,
  apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL,
  isDev: process.env.NEXT_PUBLIC_FLAVOR === "development",
  isProd: process.env.NEXT_PUBLIC_FLAVOR === "production",
};
